// extracted by mini-css-extract-plugin
export default {"title":"PartnersPage_title__veAWL","section":"PartnersPage_section__6YitV"};